import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const ReportRedirect = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // Simple redirect to public report
    navigate(`/public-report/${id}`, { replace: true });
  }, [id, navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      fontFamily: 'Arial, sans-serif',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ 
          fontSize: '48px', 
          marginBottom: '20px',
          animation: 'spin 1s linear infinite'
        }}>
          🔄
        </div>
        <h2>Loading Medical Report...</h2>
        <p style={{ color: '#666', marginTop: '10px' }}>
          Please wait
        </p>
      </div>
      
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default ReportRedirect;
